/* Boot: loader → smooth scroll wiring → all modules. */

import { initCountdown } from './countdown.js';
import { initGrain } from './grain.js';
import { initSequence } from './sequence.js';
import { initReveals } from './reveal.js';
import { initPresave } from './presave.js';

const LOADER_KEY = '70x7:intro';
const LOADER_TARGET = 490; // 70 × 7
const LOADER_MS = 1500;

const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({ ignoreMobileResize: true });

if (reducedMotion) {
  document.body.classList.add('no-motion');
} else {
  const lenis = new Lenis({ autoRaf: false });
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);
}

initGrain();
initCountdown();
initSequence(reducedMotion);
initReveals(reducedMotion);
initPresave();
runLoader();

document.fonts.ready.then(() => ScrollTrigger.refresh());

function heroEntrance(instant) {
  const els = gsap.utils.toArray('.reveal-hero');
  if (instant) {
    gsap.set(els, { opacity: 1, y: 0 });
    return;
  }
  gsap.to(els, {
    opacity: 1,
    y: 0,
    duration: 1.1,
    ease: 'expo.out',
    stagger: 0.1,
    delay: 0.1,
  });
}

function runLoader() {
  const loader = document.getElementById('loader');
  const seen = sessionStorage.getItem(LOADER_KEY);

  if (reducedMotion || seen || !loader) {
    if (loader) loader.hidden = true;
    heroEntrance(reducedMotion);
    return;
  }

  sessionStorage.setItem(LOADER_KEY, '1');
  document.body.classList.add('is-locked');
  const counter = document.getElementById('loaderCount');
  const start = performance.now();

  function tick(now) {
    const t = Math.min(1, (now - start) / LOADER_MS);
    const eased = 1 - Math.pow(1 - t, 3);
    counter.textContent = String(Math.round(eased * LOADER_TARGET)).padStart(3, '0');
    if (t < 1) {
      requestAnimationFrame(tick);
    } else {
      loader.classList.add('is-done');
      document.body.classList.remove('is-locked');
      heroEntrance(false);
      setTimeout(() => { loader.hidden = true; }, 1000);
    }
  }

  requestAnimationFrame(tick);
}
